import {insertHtmlFragment} from "@otto-ec/global-resources/dom";

export class LotteryGame {

    async init() {
        const lotteryGameElement: HTMLElement | null = document.querySelector('.promo_staticcontent--lottery-game');
        if (lotteryGameElement) {
            /*                                                             */
            await fetch("/connectfour/").then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error("[FT3] Lottery Game loading failed.");
                }
            }).then(lotteryGameHtml => {
                insertHtmlFragment(lotteryGameHtml, lotteryGameElement);
            }).catch(error => {
                console.error(error.message);
            })
        } else {
            console.error("[FT3] Lottery Game element not found.");
        }
    }

}